import { Injectable, WritableSignal } from '@angular/core';

import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { NavigationService } from '@core/services/navigation/navigation.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable()
export class PasswordChangeCommand extends BaseProfileCommand {
  readonly type = 'passwordChange';
  readonly title = 'Сменить пароль';
  readonly subtitle?: WritableSignal<string> = undefined;
  readonly icon = 'key';
  readonly checkbox?: 'unchecked' | 'checked' | 'disabled' | null = null;
  readonly hidden = false;
  readonly group = 'main';
  readonly order = 3;
  readonly settingsNames?: string[] = undefined;

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService?: CommandAvailabilityService,
    appSettingsService?: AppSettingsService
  ) {
    super(commandAvailabilityService, appSettingsService);
  }

  async execute(_context: IProfileCommandContext): Promise<void> {
    void this.navigationService.push('change-password');
  }
}
